var $35be4b468e070ce1$exports = {};
$35be4b468e070ce1$exports = {
  "collapse": "\u6536\u5408",
  "expand": "\u5C55\u958B"
};
export { $35be4b468e070ce1$exports as default };